import { render, staticRenderFns } from "./MakingAppointmentDentistAll.vue?vue&type=template&id=40084531&scoped=true&"
import script from "./MakingAppointmentDentistAll.vue?vue&type=script&lang=js&"
export * from "./MakingAppointmentDentistAll.vue?vue&type=script&lang=js&"
import style0 from "./MakingAppointmentDentistAll.vue?vue&type=style&index=0&id=40084531&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40084531",
  null
  
)

export default component.exports